import React from 'react'
import {createRoot} from 'react-dom/client'
import {TableTabs, TableTabsProps} from './TableTabs'

export interface UITableTabsView {
    render: (props: TableTabsProps) => void
}

export const createUITableTabsView = (element: HTMLElement): UITableTabsView => {
    const rootView = createRoot(element)
    return {
        render: (props: TableTabsProps) => {
            rootView.render(<TableTabs {...props} />)
        },
    }
}
